/**@jsx jsx */
import { useState } from 'react'
import { jsx, Box, Image, Grid, Flex, Select } from 'theme-ui'
import { Link, graphql } from 'gatsby'
import { baseUrl, promo_transform } from '../cloudinary-transforms'
import Sparkles from '../components/sparkles'
import Layout from '../components/layout'
import SEO from '../components/seo'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export const query = graphql`
  {
    allJobPosting {
      group(field: frontmatter___locations___location) {
        fieldValue
      }
      nodes {
        frontmatter {
          blurb
          company_name
          logo
          location
          live
          locations {
            location
          }
          featured
          roles {
            role_title
          }
        }
        slug
      }
    }
  }
`

const ProductPage = ({ data }) => {
  const [filter, setFilter] = useState({ location: 'All' })

  const featuredJobs = data.allJobPosting.nodes.filter((job) => {
    if (filter.location === 'All' && job.frontmatter.featured === true) {
      return true
    } else {
      return (
        job.frontmatter.location === filter.location &&
        job.frontmatter.featured === true
      )
    }
  })

  const jobs = data.allJobPosting.nodes.filter((job) => {
    if (
      filter.location === 'All' &&
      !job.frontmatter.featured &&
      job.frontmatter.live
    ) {
      return true
    } else {
      const availableLocations = job.frontmatter.locations.map(
        ({ location }) => location
      )

      return (
        availableLocations.includes(filter.location) &&
        !job.frontmatter.featured &&
        job.frontmatter.live
      )
    }
  })

  const locations = data.allJobPosting.group.map(
    (location) => location.fieldValue
  )

  return (
    <Layout activeMenu="jobs">
      <SEO title="Jobs" />
      <div>
        <ol sx={{ padding: '3rem' }} className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/" className="font-weight-bold">
              Home
            </Link>
          </li>
          <li className="breadcrumb-item" aria-current="page">
            Job Board
          </li>
        </ol>
      </div>

      <div
        className="page-title"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '20px',
          flexDirection: 'column',
        }}
      >
        <h1>Jobs</h1>
        <p
          sx={{
            width: ['80%', '50%'],
            marginBottom: '12px',
            textAlign: 'center',
          }}
        >
          Click on any company posting to learn more about the cool work they're
          doing and to apply to their open roles!
        </p>
        <a
          href="https://airtable.com/shrMZCJIGqqRcn45Y"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ variant: 'links.a', color: 'black' }}
        >
          Add your company here!
        </a>
      </div>

      <Flex
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          marginBottom: '40px',
        }}
      >
        <label sx={{ display: 'block' }} htmlFor="filter">
          Filter by location:
        </label>
        <Select
          id={'filter'}
          sx={{ width: '200px' }}
          onChange={(e) => setFilter({ location: e.target.value })}
          defaultValue={'All'}
        >
          <option>All</option>
          {locations.map((location, i) => (
            <option key={i}>{location}</option>
          ))}
        </Select>
      </Flex>

      {featuredJobs.length > 0 && (
        <Box>
          <Sparkles>
            <h2 sx={{ textAlign: 'center' }}>Featured</h2>
            <Grid gap={3} columns={[1, 2, 3]} sx={{ padding: '2rem' }}>
              {featuredJobs.map((job) => {
                const {
                  company_name,
                  logo,
                  blurb,
                  roles,
                  location,
                } = job.frontmatter
                const { slug } = job
                const roles_num = roles.length

                return (
                  <Link key={slug} sx={{ width: '100%' }} to={`/jobs/${slug}`}>
                    <Flex sx={{ variant: 'links.grid' }}>
                      <Box>
                        <Image
                          alt={`${company_name} logo`}
                          sx={{ marginBottom: '15px' }}
                          src={baseUrl + promo_transform + logo}
                          sx={{ height: 100, marginBottom: '10px' }}
                        />
                      </Box>
                      <h3 sx={{ color: 'darkGrey' }}>{company_name}</h3>
                      <p
                        sx={{
                          marginBottom: '10px',
                          fontWeight: '400',
                        }}
                      >
                        {blurb}
                      </p>
                      <p>
                        <span sx={{ fontWeight: 'bold' }}>Open roles:</span>
                        {` ${roles_num}`}
                      </p>
                      <p>
                        <span sx={{ fontWeight: 'bold' }}>Location:</span>{' '}
                        {location}
                      </p>
                    </Flex>
                  </Link>
                )
              })}
            </Grid>
          </Sparkles>
        </Box>
      )} 

      {featuredJobs.length > 0 && (
        <hr color={'#705ecf'} sx={{ width: '50%' }} />
      )}

      <Grid gap={3} columns={[1, 2, 3]} sx={{ padding: '2rem' }}>
        {jobs
          .filter(
            (job) => {
              return (
                (filter.location === 'All' && !job.frontmatter.featured) ||
                job.frontmatter.locations.map(
                  ({ location }) =>
                    location.includes(filter.location) &&
                    !job.frontmatter.featured
                )
              )
            }
            //   if (filter.location === 'All' && !job.frontmatter.featured) {
            //     return true
            //   } else {
            //     return job.frontmatter.locations.filter(({ location }) => {
            //       console.log('derp', job.frontmatter.company_name, location)
            //       return location === filter.location
            //     })
            //   }
            // }
          )
          .map((job) => {
            const {
              company_name,
              logo,
              blurb,
              roles,
              locations,
            } = job.frontmatter
            const { slug } = job
            const roles_num = roles.length

            return (
              <Link key={slug} sx={{ width: '100%' }} to={`/jobs${slug}`}>
                <Flex sx={{ variant: 'links.grid' }}>
                  <Box>
                    <Image
                      alt={`${company_name} logo`}
                      sx={{ marginBottom: '15px' }}
                      src={baseUrl + promo_transform + logo}
                      sx={{ height: 100, marginBottom: '10px' }}
                    />
                  </Box>
                  <h3 sx={{ color: 'darkGrey' }}>{company_name}</h3>
                  <p sx={{ marginBottom: '10px' }}>{blurb}</p>
                  <p>
                    <span sx={{ fontWeight: 'bold' }}>Open roles:</span>
                    {` ${roles_num}`}
                  </p>
                  <span
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: 'darkGrey',
                    }}
                  >
                    Locations:
                  </span>
                  <p>{locations.map(({ location }) => location).join(', ')}</p>
                </Flex>
              </Link>
            )
          })}
      </Grid>
    </Layout>
  )
}

export default ProductPage
